<template>
  <div class="pa-2">


    <v-row>
      <v-col md="6" cols="12">
        <v-card class="pa-3">
          <div class="text-h6 mb-2 text-bold text-uppercase">{{ mainStore.module.base }} - {{ mainStore.module.nom }}
          </div>


          <v-divider style="margin: 5px 0 !important"></v-divider>
          <v-row>
            <v-col cols="12" md="6">
              <div class="font-weight-bold"><v-icon class="mr-2" size="x-large" icon="mdi-credit-card-refund"
                  color="primary-dark"></v-icon>Nombre de remboursements</div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="text-h5 font-weight-bold text-right">{{ finances.refunds_nb }}</div>
            </v-col>
          </v-row>
          <v-divider style="margin: 5px 0 !important"></v-divider>
          <v-row>
            <v-col cols="12" md="6">
              <div class="font-weight-bold"><v-icon class="mr-2" size="x-large" icon="mdi-credit-card"
                  color="primary-dark"></v-icon>Total CB</div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="text-h5 font-weight-bold text-right text-green-darken-4">{{ total_cb_orga }}<span
                  class="text-h6">€</span></div>
            </v-col>
          </v-row>
          <v-divider style="margin: 5px 0 !important"></v-divider>

          <v-row>
            <v-col cols="12" md="6">
              <div><v-icon class="mr-2 ml-4" size="x-large" icon="mdi-shoe-sneaker" color="primary-dark"></v-icon>Total
                inscriptions sportives</div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="text-h6 text-right">{{ total_inscription_orga }}<span class="text-h6">€</span></div>
            </v-col>
          </v-row>
          <v-divider style="margin: 5px 0 !important"></v-divider>
          <v-row>
            <v-col cols="12" md="6">
              <div><v-icon class="mr-2 ml-4" size="x-large" icon="mdi-silverware-fork-knife"
                  color="primary-dark"></v-icon>Total des options/activités</div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="text-h6 text-right">{{ total_option_orga }}<span class="text-h6">€</span>
              </div>
            </v-col>
          </v-row>
          <v-divider style="margin: 5px 0 !important"></v-divider>
          <v-row>
            <v-col cols="12" md="6">
              <div><v-icon class="mr-2 ml-4" size="x-large" icon="mdi-handshake" color="primary-dark"></v-icon>Total des
                donations</div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="text-h6 text-right">{{ parseFloat(finances.don_total) }}<span class="text-h6">€</span></div>
            </v-col>
          </v-row>

          <v-divider style="margin: 5px 0 !important"></v-divider>
          <v-row>
            <v-col cols="12" md="6">
              <div class="font-weight-bold"><v-icon class="mr-2" size="x-large" icon="mdi-credit-card-refund"
                  color="primary-dark"></v-icon>Total des remboursements</div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="text-h5 font-weight-bold text-right text-red-darken-4">-{{
                parseFloat(finances.refunds_total_orga) + parseFloat(finances.refunds_total_frais) }}<span
                  class="text-h6">€</span></div>
              <div class="text-subtitle-2 font-weight-bold text-right text-red-darken-4">(dont {{
                finances.refunds_total_frais }}€ de frais)</div>
            </v-col>
          </v-row>
          <v-divider :thickness="3" class="border-opacity-75" style="margin: 5px 0 !important"></v-divider>
          <v-row>
            <v-col cols="12" md="6">
              <div><v-icon class="mr-2" size="x-large" icon="mdi-file-document-edit" color="primary-dark"></v-icon>Total
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="text-h6 text-right">{{ parseFloat(total_a_retroceder) }}<span class="text-h6">€</span>
              </div>
            </v-col>
          </v-row>
          <v-divider style="margin: 5px 0 !important"></v-divider>
          <v-row>
            <v-col cols="12" md="6">
              <div><v-icon class="mr-2" size="x-large" icon="mdi-file-document-edit"
                  color="primary-dark"></v-icon>Montant déjà rétrocédé</div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="text-h6 text-right">{{ parseFloat(finances.retrocede) }}<span class="text-h6">€</span></div>
            </v-col>
          </v-row>
          <v-divider style="margin: 5px 0 !important"></v-divider>
          <v-row>
            <v-col cols="12" md="6">
              <div class="font-weight-bold"><v-icon class="mr-2" size="x-large" icon="mdi-file-document-edit"
                  color="primary-dark"></v-icon>Montant restant à rétroceder</div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="text-h5 font-weight-bold text-right">{{ restant_a_retroceder }}<span class="text-h6">€</span>
              </div>
            </v-col>
          </v-row>
          <SportipsButton v-if="mainStore.authAdmin.hasSuperAdminRights" class="mt-4" chevron icon="mdi-plus"
            @onClick="showDetails">Finances détaillées
          </SportipsButton>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="showDetailsDialog" width="500" max-width="100%" scroll-strategy="none">
      <v-card>
        <FinancesDetails :finances="finances"></FinancesDetails>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";

import AdminService from "@/services/admin.service";
import FinancesDetails from "@/components/Administration/Dashboard/Finances/FinancesDetails.vue";
export default {
  components: { FinancesDetails },
  data() {
    return {
      finances: {},
      categories: [],
      showDetailsDialog: false,
    };
  },
  computed: {
    ...mapStores(useMainStore),
    restant_a_retroceder() {
      let restant = parseFloat(this.total_a_retroceder) - parseFloat(this.finances.retrocede);
      return restant.toFixed(2);
    },
    total_a_retroceder() {
      let total = 0;
      total = parseFloat(this.total_cb_orga) - parseFloat(this.finances.refunds_total_orga) - parseFloat(this.finances.refunds_total_frais);
      return total.toFixed(2);
    },
    total_cb_orga() {
      let total = 0;
      total = parseFloat(this.finances.module_total_cb_without_taxes) - parseFloat(this.finances.gia_total) - parseFloat(this.finances.bookingsold_total) - parseFloat(this.finances.bourse_dossard_total_frais_acheteur) - parseFloat(this.finances.alerte_sms_total) - parseFloat(this.finances.plan_entrainement_total || 0);
      return total.toFixed(2);
    },
    total_inscription_orga() {
      let total = 0;
      total = parseFloat(this.finances.booking_total_inscription) + parseFloat(this.finances.lost_credits_total);
      return total.toFixed(2);
    },
    total_option_orga() {
      let total = 0;
      total = parseFloat(this.finances.booking_total_options);
      return total.toFixed(2);
    },




  },
  methods: {
    showDetails() {
      this.showDetailsDialog = true;
    },
    async get() {
      let req = await AdminService.getFinances(this.mainStore.module.base);
      if (req) {
        this.finances = req.finances;
      }
    },
  },
  async created() {
    await this.get();
  },
};
</script>

<style lang="scss" scoped></style>